<template>
  <v-list-item
    :to="assignmentDetailsRoute"
    three-line
  >
    <v-list-item-content>
      <v-list-item-title class="font-weight-medium">
        {{ assignment.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        <span>{{ assignment.subject }}</span>
        <span class="mx-1">•</span>
        <span class="text-lowercase">{{ assignment.type }}</span>
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        <span>{{ assignmentAvailableDates }}</span>
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-list-item-action-text>
        <v-chip
          v-if="isRunningAssignment"
          small
          color="warning"
        >
          {{ runningTestTimer }}
        </v-chip>
        <span v-else>{{ testDuration }}</span>
      </v-list-item-action-text>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        :disabled="!canRunAssignment"
        :loading="testLoading"
        :to="assignmentTestRoute"
        large
        icon
        outlined
        color="primary"
        @click.stop=""
      >
        <v-icon>play_arrow</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatAssignmentDuration } from '@/helpers/assignments/format';

export default {
  name: 'AssignmentListItem',
  props: {
    assignment: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('assignments', [
      'assignmentsTimers',
      'runningAssignments',
      'currentPeriodAssignments',
      'testsLoading',
    ]),
    canRunAssignment() {
      return this.currentPeriodAssignments.some(a => a._id === this.assignment._id);
    },
    isRunningAssignment() {
      return this.runningAssignments.some(a => a._id === this.assignment._id);
    },
    runningTestTimer() {
      return this.assignmentsTimers[this.assignment._id]?.format('HH:mm:ss');
    },
    testDuration() {
      if (!this.assignment.duration) {
        return null;
      }
      return formatAssignmentDuration(this.assignment.duration);
    },
    testLoading() {
      return this.testsLoading[this.assignment._id];
    },
    assignmentAvailableDates() {
      const format = 'MM/DD/YYYY hh:mm A';
      const startDate = this.$moment(this.assignment.startDate).format(format);
      const dueDate = this.$moment(this.assignment.dueDate).format(format);
      return `Available from ${startDate} until ${dueDate}`;
    },
    assignmentDetailsRoute() {
      return { name: 'profile-assignment', params: { assignmentId: this.assignment._id } };
    },
    assignmentTestRoute() {
      return { name: 'profile-assignment-test', params: { assignmentId: this.assignment.id } };
    },
  },
};
</script>
